import * as PIXI from 'pixi.js'

import { applyDisplayObjectProps } from '../utils/props'
import TYPES from '../utils/types'

export const Graphics = (root, props) => {
  const $el = new PIXI.Graphics()

  const applyMask = () => {
    $el.parent.mask = $el
  }

  $el.applyProps = (instance, oldProps, newProps) => {
    const { asMask, draw, ...props } = newProps
    applyDisplayObjectProps(instance, oldProps, props)

    if (typeof draw === 'function') {
      $el.clear()
      draw.call($el, $el)
    }

    if (!oldProps.asMask && asMask) {
      $el.on('added', applyMask)
    }

    if (oldProps.asMask && !asMask) {
      $el.off('added', applyMask)
      if ($el.parent && $el.parent.mask === $el) {
        $el.parent.mask = null
      }
    }
  }

  return $el
}

export default TYPES.Graphics
